module.exports = __webpack_public_path__ + "img/sistecredito_.c0ae32ca.svg";